import { render, staticRenderFns } from "./DefectName.vue?vue&type=template&id=7385edf8&"
import script from "./DefectName.vue?vue&type=script&lang=js&"
export * from "./DefectName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports